import { ref, computed } from 'vue'

// State - these will be initialized in the composable function
export const currentTab = ref(null)
export const socialAuths = ref({})
export const loading = ref(false)

// Computed factory functions
export const createTabs = (components, t) => computed(() => [
  { name: 'posts', label: t('socialMedia.tabs.posts'), component: components.posts },
  { name: 'new-content', label: t('socialMedia.tabs.new_content'), component: components.newContent },
])

export const createCurrentTabComponent = (tabs) => computed(() => {
  const tab = tabs.value.find(tab => tab.name === currentTab.value)
  return tab ? tab.component : null
})
